<template>
  <div class="selected-fiduciary">
    <p>{{ selectedFiduciaryName }}</p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SelectedFiduciary',
  computed: {
    ...mapState({
      selectedFiduciaryName: (state) => state.user.fiduciary.name,
    }),
  },
};
</script>

<style lang="scss">
.selected-fiduciary {
  margin: $mds-space-2-x;
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-l;
}
</style>
